import { useMutation, useQueryClient } from "@tanstack/react-query"
import { toast } from "sonner"

import { supabase } from "@/lib/supabase"

export interface UpdateDiaryEntryParams {
  id: string // Supabase UUID
  followUpComplete: boolean
}

export const useUpdateDiaryEntry = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (params: UpdateDiaryEntryParams) => {
      const { data, error } = await supabase.functions.invoke("update-diary-entry", {
        body: params,
      })

      if (error) {
        console.error("Error updating diary entry:", error)
        throw new Error(error.message || "Failed to update diary entry")
      }

      return data
    },
    onSuccess: (_data) => {
      // Invalidate diary entries query to refetch the data
      queryClient.invalidateQueries({
        queryKey: ["diaryEntries"],
      })

      toast.success("Success", {
        description: "Diary entry updated successfully",
      })
    },
    onError: (error: Error) => {
      toast.error("Error", {
        description: error.message || "Failed to update diary entry",
      })
    },
  })
}
